import { useEffect } from "react";
import { useQuery, useSubscription } from "@apollo/client";
import { useDispatch } from "react-redux";
import {
  QUERY_DRIVER_GPS_DATA,
  SUBSCRIBE_DRIVER_GPS_DATA,
} from "../queries/driverGPSQueries";
import { setDriverGPSData } from "../../../state/driverGPSReducer";

export function QueryDriverGPSData() {
  const dispatch = useDispatch();
  const { data, loading, error } = useQuery(QUERY_DRIVER_GPS_DATA);
  if (error) {
    console.log(error);
  }
  useEffect(() => {
    if (data) {
      dispatch(setDriverGPSData(data.getDriverGPSData));
    }
  }, [dispatch, data, loading, error]);
}

export function SubscribeDriverGPSData() {
  const dispatch = useDispatch();
  const { error } = useSubscription(SUBSCRIBE_DRIVER_GPS_DATA, {
    onData: (x) => {
      const driverGPSUpdate = x.data.data.newDriverGPSData;
      dispatch(setDriverGPSData(driverGPSUpdate));
    },
  });
  if (error) {
    console.log(error);
  }
}
